/**
 * 邮箱会话ID管理器
 * 负责管理邮箱会话ID，提供获取、更新等功能
 * @author 杨俊朗
 */
export class IamEmailSessionIdManager {
  private static instance: IamEmailSessionIdManager;
  private store: string = "";

  private constructor() {}

  // 单例模式
  public static getInstance(): IamEmailSessionIdManager {
    if (!IamEmailSessionIdManager.instance) {
      IamEmailSessionIdManager.instance = new IamEmailSessionIdManager();
    }
    return IamEmailSessionIdManager.instance;
  }

  // 更新邮箱会话ID
  public update(value: string): void {
    console.log("update email session ID store", value, import.meta.url);
    this.store = value;
  }

  // 获取邮箱会话ID
  public get(): string {
    return this.store;
  }

  // 清除邮箱会话ID
  public clear(): void {
    this.update("");
  }
}

export const iamEmailSessionIdManager = IamEmailSessionIdManager.getInstance();
